export const CRUD = {
  Create: 'Create',
  Read: 'Read',
  Update: 'Update',
  Delete: 'Delete'
};
